export default __webpack_public_path__ + "static/media/ic_niger.21443dda.svg";